import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from 'src/app/core/services/product.service';
import { IProductConfig } from '../../../core/models';

@Component({
  selector: 'app-product-config',
  templateUrl: './product-config.component.html',
  styleUrls: ['./product-config.component.scss']
})
export class ProductConfigComponent implements OnInit, OnDestroy {
  public paramsSubscription: Subscription;
  public productConfigurations: Array<IProductConfig> = [];
  productId: number = 0;

  constructor(private productService: ProductService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void{
    this.paramsSubscription = this.route.params.subscribe(params => {
      console.log('The id of this route is: ', params.id);
      this.productId = +params.id;
    });
    const body = {
      productId: this.productId,
      languageCode: localStorage.getItem('language')
    }
    this.productService.getProductDetailsByProductId(body).subscribe((productConfigurations) => {
      this.productConfigurations = productConfigurations;
    });

  }
  ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
  }

  gotoConfigureProduct(routepath: string): void {
   
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });
  }
}
